import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faUser } from "@fortawesome/free-solid-svg-icons"

export const User = (props) => {
  return <FontAwesomeIcon faIcon={faUser} {...props} />
}
